import React, { useContext, useState } from 'react';
import { Popover, RatingMeter } from '@one-thd/sui-atomic-components';
import {
  arrayOf,
  extend,
  number,
  params,
  shape,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { StorePodContext } from '../StorePod.context';
import { RatingDetailed } from './RatingDetailed';
import { StorePodLoader } from './StorePodLoader';

const RatingLoader = () => (
  <div data-testid="store-pod-rating-loader" style={{ width: '8.375rem' }}>
    <StorePodLoader height="3.2rem" />
  </div>
);

export const StorePodRating = () => {
  const { loading, store } = useContext(StorePodContext);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const { storeId } = store || {};
  const options = {
    variables: {
      storeId
    },
    skip: !storeId
  };

  const { data } = useDataModel('storeReviews', options);

  const {
    AverageOverallRating: averageOverallRating,
    NotRecommendedCount: notRecommendedCount,
    RatingDistribution: ratingDistribution,
    RecommendedCount: recommendedCount,
    TotalReviewCount: totalReviewCount
  } = data?.storeReviews?.Includes?.Products?.store?.FilteredReviewStatistics || {};

  const open = Boolean(anchorEl);
  const id = open ? 'storePodRating-popover' : undefined;
  const isLoading = loading || !totalReviewCount || !averageOverallRating;

  return (
    <span data-component="StorePodRating">
      {isLoading
        ? <RatingLoader />
        : (
          <>
            <RatingMeter
              onClick={handleClick}
              value={Number(averageOverallRating)}
              label={`(${totalReviewCount})`}
              data-testid="store-pod-rating-meter"
            />
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              placement="bottom-start"
              title="Store Ratings"
            >
              <RatingDetailed
                averageOverallRating={averageOverallRating}
                notRecommendedCount={notRecommendedCount}
                ratingDistribution={ratingDistribution}
                recommendedCount={recommendedCount}
                totalReviewCount={totalReviewCount}
              />
            </Popover>
          </>
        )}
    </span>
  );
};

StorePodRating.propTypes = {};

StorePodRating.defaultProps = {};

StorePodRating.displayName = 'StorePodRating';

StorePodRating.dataModel = extend({
  storeReviews: params({
    storeId: stringType().isRequired()
  }).shape({
    Includes: shape({
      Products: shape({
        store: shape({
          FilteredReviewStatistics: shape({
            AverageOverallRating: stringType(),
            NotRecommendedCount: number(),
            RatingDistribution: arrayOf(shape({
              RatingValue: number(),
              Count: number(),
            })),
            RecommendedCount: number(),
            TotalReviewCount: number()
          }),
        })
      })
    })
  })
});
